import { createGlobalStyle } from 'styled-components';
import helpers from '@gloat/helpers';
import { TOP_NAVBAR_HEIGHT } from '../top-navbar';
import { BoxProps, Flex } from '../../box';

const GlobalStyle = createGlobalStyle`
    body {
        overflow: hidden;
    }

    #main-app-container {
        height: 100%;
        padding-top: ${helpers.isArrivedFromWebview() || helpers.teams.isUnderTeams() ? 0 : TOP_NAVBAR_HEIGHT}px;
    }

`;

export const LayoutWrapper = ({
  height = `calc(100vh - ${helpers.isArrivedFromWebview() ? '0px' : `${TOP_NAVBAR_HEIGHT}px`})`,
  ...props
}: BoxProps) => {
  return (
    <>
      <Flex overflow={'hidden'} height={height} {...props} />
      <GlobalStyle />
    </>
  );
};
